export interface Product {
  id: string;
  name: string;
  type: string;
  image: string;
}

export interface NavOption {
  label: string;
  to: string;
  disabled?: boolean;
  exact?: boolean;
  onClick?: () => void;
}

export interface NavButton {
  label: string;
  action: any;
  disabled?: boolean;
}

export interface ActionOptions {
  search?: () => void;
  apps?: () => void;
  language?: () => void;
  notification?: () => void;
  settings?: () => void;
  user?: () => void;
}

export enum ToastColor {
  BLACK,
  WHITE,
  BLUE,
  GREEN,
  ORANGE,
  RED,
}

export enum ToastPosition {
  TOPLEFT,
  TOPMIDDLE,
  TOPRIGHT,
  BOTTOMLEFT,
  BOTTOMMIDDLE,
  BOTTOMRIGHT,
}

export interface SwitcherNavItem {
  label: string;
  url: string;
  disabled?: boolean;
  Icon?: any;
  as?: any;
  testId?: string;
}

export interface UserMenuItem {
  label: string;
  to: string;
  icon: any;
  isExternal?: boolean;
  onClick?: () => void;
}

export interface ListRowDropdownOption {
  key?: string;
  label: string;
  action: any;
}
